import { BorderBottom } from "@mui/icons-material";
import React from "react";

const tabHeaderStyle = {
  position: "relative",
  padding: "6px 12px",
  background: "transparent",
  cursor: "pointer",
  fontWeight: "500",
  fontSize: "16px",
  color: "#888",
  border: "none",
  outline: "none",
};

const activeHeaderStyle = {
  ...tabHeaderStyle,
  color: "#000",
  fontWeight: "600",
};

const underlineBaseStyle = {
  position: "absolute",
  bottom: "0px",
  left: 0,
  height: "3px",
  width: "100%",
  backgroundColor: "#028509ff",
  transformOrigin: "left",
  transform: "scaleX(0)",
  transition: "transform 0.3s ease-out",
  borderRadius: "2px",
};

const underlineActiveStyle = {
  ...underlineBaseStyle,
  transform: "scaleX(1)",
};

const containerStyle = {
  marginTop: "10px",
};

const contentStyle = {
  background: "#ffffffff",
  borderRadius: "6px 6px 6px 6px",
  padding: "30px 26px",
  boxShadow: "0 1px 10px rgba(0,0,0,0.04)",
  border: "1px solid lightgrey",
  marginTop: "5px",
};

function TabsPharma({ tabs, activeTab, setActiveTab }) {
  return (
    <div style={containerStyle}>
      <div style={{ display: "flex" }}>
        {tabs.map((tab, index) => (
         <div key={tab.title} style={{ padding: "5px", position: "relative" }}>
  <button
    type="button"
    style={activeTab === index ? activeHeaderStyle : tabHeaderStyle}
    onClick={() => setActiveTab(index)}
  >
    {tab.title}
    <span
      style={activeTab === index ? underlineActiveStyle : underlineBaseStyle}
    />
  </button>
</div>
        ))}
      </div>
      <div style={contentStyle}>{tabs[activeTab].content}</div>
    </div>
  );
}

export default TabsPharma;
